import React, { FC } from 'react';

import { IFAQ } from '@/src/assets/interfaces/faqInterface';
import { ITheme } from '@/src/assets/interfaces/themeInterface';
import { advInfoShort } from '@/src/assets/objects/advInfo';
import { baseUrl } from '@/src/assets/utils/baseUrl';

import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import AdvantageList from '../../advantageList/AdvantageList';
import Layout from '../../layout/Layout';
import BundleSection from '../../sections/bundleSection/BundleSection';
import FAQSection from '../../sections/faqSection/FAQSection';
import Hero from '../../sections/hero/Hero';
import LatestSection from '../../sections/latestSection/LatestSection';
import SupportSection from '../../sections/supportSection/SupportSection';

import styles from './Home.module.scss';

type THome = {
    faq: IFAQ[];
    featured: Partial<ITheme>;
    themes: ITheme[];
};

const Home: FC<THome> = ({ faq, featured, themes }) => {
    const standardThemes =
        themes && featured && themes.filter((item) => featured.title !== item.title);

    const jsonLd = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: 'High Five Themes',
        description:
            'Harness the ethereal power of this platform to captivate your audience and unleash the full potential of your content.',
        url: `${baseUrl()}`,
    };
    const heading = 'Essential Theme Features for Enhanced Online Performance';

    return (
        <Layout
            meta={{
                metaTitle: 'High Five Themes – Premium Ghost Themes & Templates',
                metaDescription:
                    'High-performance Ghost themes designed for modern publishers, fully responsive and optimized for speed, SEO, and Ghost 5.0+.',
                ogTitle: 'High Five Themes – Premium Ghost Themes to Captivate Any Audience',
                ogDescription:
                    'High-performance, responsive Ghost themes for every publisher, expertly designed for Ghost 5.0+ and the next generation of publishing.',
            }}
            jsonLD={jsonLd}>
            <Hero />
            <LatestSection standartThemes={standardThemes} featured={featured} />
            <section className={styles.advantages__section}>
                <Wrapper>
                    <Title text={heading} size="lg" className={styles.advantages__title} />
                    <AdvantageList advList={advInfoShort} />
                </Wrapper>
            </section>
            <BundleSection className={styles.bundle} showLink={true} />
            <FAQSection faqList={faq} />
            {featured && (
                <SupportSection
                    bgImage={featured.supportSectionImage!}
                    descr={featured.supportSectionDescription!}
                    title={featured.supportSectionTitle!}
                    docs={featured.documentationUrl!}
                />
            )}
        </Layout>
    );
};

export default Home;
